import { printBrowserText } from '../sharing/browserSharing';

export const printProfileShareSnapshot = (title, text) => printBrowserText({ title, text });
